function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "226,105.022 226,168.978 273.959,137  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M512,0H0v272h512V0z M196,48.978L328.041,137L196,225.022V48.978z M316,233.211L294.789,212L316,190.789L337.211,212   L316,233.211z M376,233.211L354.789,212L376,190.789L397.211,212L376,233.211z M436,233.211L414.789,212L436,190.789L457.211,212   L436,233.211z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151,407c0-24.853-20.147-45-45-45H45c-24.853,0-45,20.147-45,45v105h151V407z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M331,407c0-24.853-20.147-45-45-45h-60c-24.853,0-45,20.147-45,45v105h150V407z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512,407c0-24.853-21.147-45-46-45h-60c-24.853,0-45,20.147-45,45v105h151V407z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M346,362.463C359.682,344.085,381.38,332,406,332h12.246c-6.198-17.437-22.681-30-42.246-30h-60   c-19.565,0-36.048,12.563-42.246,30H286C310.62,332,332.318,344.085,346,362.463z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M238.246,332c-6.198-17.437-22.681-30-42.246-30h-60c-19.565,0-36.048,12.563-42.246,30H106   c24.62,0,46.318,12.085,60,30.463C179.682,344.085,201.38,332,226,332H238.246z"
}));

function Svg67(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "inherit",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg67);
export default __webpack_public_path__ + "static/media/6_7.6c1daf62.svg";
export { ForwardRef as ReactComponent };